import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import BookingHelpBanner from "./components/BookingHelpBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Team from "./pages/Team";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Booking from "./pages/Booking";
import BookingSuccess from "./pages/BookingSuccess";
import ManageBookings from "./pages/ManageBookings";
import Contact from "./pages/Contact";
import Gemstones from "./pages/Gemstones";
import Admin from "./pages/Admin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CancellationPolicy from "./pages/CancellationPolicy";
import BirthChartAnalysis from "./pages/BirthChartAnalysis";
import HealthAstrology from "./pages/HealthAstrology";
import BusinessAstrology from "./pages/BusinessAstrology";
import MarriageAstrology from "./pages/MarriageAstrology";
import KundliReading from "./pages/KundliReading";
import VedicAstrologyServices from "./pages/VedicAstrologyServices";
import TestSEO from "./pages/TestSEO";
import Calculators from "./pages/Calculators";
import FlamesCalculator from "./pages/FlamesCalculator";
import LoveCalculator from "./pages/LoveCalculator";
import AscendantCalculator from "./pages/AscendantCalculator";
import MangalDoshCalculator from "./pages/MangalDoshCalculator";
import KaalSarpDoshCalculator from "./pages/KaalSarpDoshCalculator";
import MoonPhaseCalculator from "./pages/MoonPhaseCalculator";
import FreeKundliTools from "./pages/FreeKundliTools";
import FreeKundli from "./pages/FreeKundli";
import YourNakshatra from "./pages/YourNakshatra";
import DailyHoroscope from "./pages/DailyHoroscope";
import MonthlyHoroscope from "./pages/MonthlyHoroscope";
import YearlyHoroscope from "./pages/YearlyHoroscope";
import KundliHindi from "./pages/KundliHindi";
import Panchang from "./pages/Panchang";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <LanguageProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollToTop />
              <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/services" element={<Services />} />
              <Route path="/testimonials" element={<Testimonials />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route
                path="/booking"
                element={
                  <ProtectedRoute>
                    <Booking />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/booking-success/:bookingId"
                element={
                  <ProtectedRoute>
                    <BookingSuccess />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/manage-bookings"
                element={
                  <ProtectedRoute>
                    <ManageBookings />
                  </ProtectedRoute>
                }
              />
              <Route path="/contact" element={<Contact />} />
              <Route path="/gemstones" element={<Gemstones />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/cancellation-policy" element={<CancellationPolicy />} />
              <Route path="/birth-chart-analysis" element={<BirthChartAnalysis />} />
              <Route path="/health-astrology-prediction" element={<HealthAstrology />} />
              <Route path="/business-astrology-consultation" element={<BusinessAstrology />} />
              <Route path="/marriage-astrology-consultation" element={<MarriageAstrology />} />
              <Route path="/kundli-reading-ghaziabad" element={<KundliReading />} />
              <Route path="/vedic-astrology-services-ghaziabad" element={<VedicAstrologyServices />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/calculator/flames" element={<FlamesCalculator />} />
              <Route path="/calculator/love" element={<LoveCalculator />} />
              <Route path="/calculator/ascendant" element={<AscendantCalculator />} />
              <Route path="/calculator/mangal-dosh" element={<MangalDoshCalculator />} />
              <Route path="/calculator/kaal-sarp-dosh" element={<KaalSarpDoshCalculator />} />
              <Route path="/calculator/moon-phase" element={<MoonPhaseCalculator />} />
              <Route path="/free-kundli-tools" element={<FreeKundliTools />} />
              <Route path="/kundli" element={<FreeKundli />} />
              <Route path="/nakshatra" element={<YourNakshatra />} />
              <Route path="/daily-horoscope" element={<DailyHoroscope />} />
              <Route path="/monthly-horoscope" element={<MonthlyHoroscope />} />
              <Route path="/yearly-horoscope" element={<YearlyHoroscope />} />
              <Route path="/kundli-hindi" element={<KundliHindi />} />
              <Route path="/panchang" element={<Panchang />} />
              <Route path="/test-seo" element={<TestSEO />} />
            </Routes>
              <Footer />
              <BookingHelpBanner />
              <Toaster />
            </BrowserRouter>
          </div>
        </LanguageProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
